interface IFeatureFlags {
  CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: boolean
  ALLOW_OLD_PREVIEW_PAGE: boolean
  /**
   * Gate for the dynamic header / footer editing capability. Combined with a
   * `documentVersion >= 3` check at every UI entry point so v2 documents can
   * no longer enter header / footer edit mode (the feature is v3-only). Flip
   * this off to kill the whole feature instantly without redeploying.
   */
  ENABLE_HEADER_FOOTER: boolean
}

const configuration: Record<string, IFeatureFlags> = {
  development: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
    ENABLE_HEADER_FOOTER: true,
  },
  staging: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
    ENABLE_HEADER_FOOTER: true,
  },
  interop: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
    ENABLE_HEADER_FOOTER: true,
  },
  beta: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
    ENABLE_HEADER_FOOTER: true,
  },
  production: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
    ALLOW_OLD_PREVIEW_PAGE: false,
    ENABLE_HEADER_FOOTER: true,
  },
}

export const featureFlags = configuration[(process.env.mode || process.env.NODE_ENV) as string]
